var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"inputFile",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple,"hidden":""},on:{"input":_vm.fileSelected}}),_vm._t("default",function(){return [_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":_vm.openFileDialog}},[_vm._v(_vm._s(_vm.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }